import logo from '../logo.png';

const services = ['Cyber Security', 'Software Development', 'Network Solutions', 'IS Audit & Compliance', 'UI Design', 'Process Optimisation'];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--navy-mid)', borderTop: '1px solid rgba(0,172,193,0.14)', padding: '60px 5% 32px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr', gap: 60, marginBottom: 48 }} className="footer-grid">

          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
              <img src={logo} alt="KP Technologies" style={{ height: 48 }} />
            </div>
            <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.8, fontWeight: 300, maxWidth: 300 }}>
              Reliable technology consulting for businesses that refuse to compromise. Security, software, networks, compliance — delivered with precision.
            </p>
            <div style={{ marginTop: 24 }}>
              <span style={{ fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 22, color: 'var(--teal-dark)' }}>KP Technologies</span>
              <div style={{ fontFamily: 'Space Mono', fontSize: 10, color: 'var(--text-muted)', letterSpacing: '0.15em', marginTop: 4 }}>WHERE RELIABILITY COMES FIRST</div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 16, color: 'var(--text-main)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Services</h4>
            <ul style={{ listStyle: 'none' }}>
              {services.map(s => (
                <li key={s} style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 12, fontWeight: 300, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'var(--teal)', display: 'inline-block', flexShrink: 0 }} />
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 style={{ fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 16, color: 'var(--text-main)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Company</h4>
            {['About', 'Why Us', 'Contact'].map(l => (
              <div key={l} style={{ marginBottom: 12 }}>
                <button onClick={() => document.getElementById(l.toLowerCase().replace(' ', '-'))?.scrollIntoView({ behavior: 'smooth' })}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', fontSize: 14, fontWeight: 300, fontFamily: 'Outfit', padding: 0, transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = 'var(--teal)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}>{l}</button>
              </div>
            ))}
            <div style={{ marginTop: 28 }}>
              <a href="https://wa.me/919988778877" target="_blank" rel="noreferrer"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: 'rgba(37,211,102,0.12)', border: '1px solid rgba(37,211,102,0.3)',
                  color: '#25D366', fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 14,
                  letterSpacing: '0.05em', padding: '10px 18px', borderRadius: 4,
                  transition: 'background 0.2s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,211,102,0.2)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(37,211,102,0.12)'}>
                💬 WhatsApp Us
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(15,23,42,0.08)', marginBottom: 28 }} />

        {/* Bottom bar */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>
            © 2026 KP Technologies LLP. All rights reserved.
          </p>
          <p style={{ color: 'rgba(71,85,105,0.75)', fontSize: 12, fontFamily: 'Space Mono' }}>
            WHERE RELIABILITY COMES FIRST
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </footer>
  );
}
